export type FeedbackTone = "info" | "error";
export interface FeedbackNotice {
  id: number;
  message: string;
  tone: FeedbackTone;
}
let nextId = 0;
const listeners = new Set<(notice: FeedbackNotice) => void>();
let previous: FeedbackNotice | undefined;
let previousAt = 0;

/** Share action feedback without tying the API client to React. */
export function publishFeedback(message: string, tone: FeedbackTone = "info") {
  const text = message.trim();
  if (!text) return;
  const now = Date.now();
  // API errors and their inline handlers often report the same result together.
  if (previous?.message === text && now - previousAt < 1500) {
    if (tone !== "error" || previous.tone === "error") return;
  }
  const notice = { id: ++nextId, message: text, tone };
  previous = notice;
  previousAt = now;
  listeners.forEach((listener) => listener(notice));
}

export function subscribeFeedback(listener: (notice: FeedbackNotice) => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
